import { useFluxo } from "../../../../../../contexts/FlowContext";
import EditCondicionalAuto from "./EditCondicionalAuto";

export default function DialogsGallery() {

    const {
        openModais,
        handleOpenModais,
    } = useFluxo();

    return (
        <>
            {
                openModais.editCondicionalAuto &&
                <EditCondicionalAuto
                    open={Boolean(openModais.editCondicionalAuto)}
                    handleClose={() => handleOpenModais("editCondicionalAuto", null)}
                />
            }
        </>
    )
}